import {
  Box,
  Checkbox,
  Chip,
  Collapse,
  FormControlLabel,
  FormGroup,
  List,
  ListItemButton,
  ListSubheader,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CourseTable from "./CourseTable";
import { useDispatch, useSelector } from "react-redux";
import { ieltsCourseFilterAction, ieltsCourseManagmentCourseFindAction } from "../../../../actions/IeltsActions/courseManagmentAction";
import IeltsFilter from "../examTips/ExamFilter"

function IeltsCoursesMain({ subMenu }) {
  const columns = [
    { title: "SL NO", field: "sl" },
    { title: "TITLE", field: "title" },
    { title: "DURATION", field: "duration" },
    { title: "PRICE", field: "price" },
    { title: "COURSE TYPE", field: "course type" },
    { title: "STATUS", field: "status" },
  ];
  const dispatch = useDispatch();
  const [courseList, setCourseList] = useState([]);
  const [secListopen, setSecListOpen] = useState(true);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [stateList, setStateList] = useState([
    "Listing",
    "Reading",
    "Speaking",
    "Writing",
    "Grammar",
    "Exam Tips",
    "Question Bank",
  ]);

  const handleCheckCountry = (event, branchId, CheckedValue) => {
    if (event !== "gender") {
      setSelectedCountry(branchId === selectedCountry ? null : branchId);
      //   props.LeadFilterFunction(branchId, CheckedValue, event.target.checked);

      const searchText = event.target.cheked;

      if (searchText === false) {
        // setCountryList(uniqueCountries); // Reset to the original data when search text is empty
      }
    } else {
      //   props.LeadFilterFunction(branchId.target.value, "gender", true);
    }
  };

  const handleClick2 = () => {
    setSecListOpen(!secListopen);
  };

  const [ids, setIds] = useState([]);

  const selectBoxIdPassHandler = (ids) => {
    setIds(ids);
  };

  const handleDelete = () => {
    alert("You deleted the chip");
  };

  // Find created courses

  let {
    ieltsCourseManagmentCourseFindSuccess,
    ieltsCourseManagmentCourseFinderror,
  } = useSelector((state) => {
    return state.ieltsCourseManagmentCourseFind;
  });

  let {
    ieltsCourseManagmentCourseStatusChangeSuccess,
    ieltsCourseManagmentCourseStatusChangeerror,
  } = useSelector((state) => {
    return state.ieltsCourseManagmentCoursesStatusChange;
  });

  let {
    ieltsCourseManagmentCourseCreatingSuccess,
    ieltsCourseManagmentCourseCreatingerror,
  } = useSelector((state) => {
    return state.ieltsCourseManagmentCourseCreating;
  });

  const { ieltsCourseFilterSuccess } = useSelector((state) => state.ieltsCourseFilter)

  useEffect(() => {
    dispatch(ieltsCourseManagmentCourseFindAction());
  }, [
    dispatch,
    ieltsCourseManagmentCourseStatusChangeSuccess,
    ieltsCourseManagmentCourseCreatingSuccess,
  ]);

  useEffect(() => {
    if (ieltsCourseManagmentCourseFindSuccess) {
      setCourseList(ieltsCourseManagmentCourseFindSuccess?.data);
    }
  }, [dispatch, ieltsCourseManagmentCourseFindSuccess]);

  useEffect(() => {
    if(ieltsCourseFilterSuccess) {
      setCourseList(ieltsCourseFilterSuccess?.data)
    }
  }, [dispatch, ieltsCourseFilterSuccess])

  const [page, setPage] = useState(10);

  const handleClearAllFunction = () => {
    try {

    } catch(error) {
      console.error(error);
    }
  }

  const leadFilterFunction = (filterData) => {
    try {
      console.log(120,filterData)
      dispatch(ieltsCourseFilterAction(filterData))
    } catch(error) {
      console.error(error);
    }
  }

  return (
    <>
      <Box
        sx={{
          mt: 2,
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            lg: "330px 1fr",
          },
          gap: "25px",
        }}
      >
        <Box>
          {/* {selectedCategory &&  */}
          <Chip
            sx={{
              "&.MuiChip-root": {
                pl: "5px",
                pr: "5px",
              },
            }}
            label={
              <Typography
                sx={{
                  fontSize: "10px",
                  fontWeight: "700",
                  color: "rgba(88, 94, 106, 1)",
                }}
              >
                Category:{" "}
                <Typography
                  sx={{
                    fontSize: "10px",
                    fontWeight: "400",
                  }}
                  component={"span"}
                >
                  {/* {selectedCategory} */}
                </Typography>
              </Typography>
            }
            onDelete={handleClearAllFunction}
          />
          {/* } */}

          <IeltsFilter
            leadFilterFunction={leadFilterFunction}
            componentName="course"
          />
        </Box>

        <CourseTable
          data={courseList}
          columns={columns}
          component="questionBank"
          selectBoxIdPassHandler={selectBoxIdPassHandler}
          pageNumber={page}
          subMenu={subMenu}
        />
      </Box>
    </>
  );
}

export default IeltsCoursesMain;

